import axios from './axios.js';

const api = {};

const $get = (path) => axios.get(process.env.MIX_API_URL + '/v1' + path);
const $post = (path, data) => axios.post(process.env.MIX_API_URL + '/v1' + path, data);
const $put = (path, data) => axios.put(process.env.MIX_API_URL + '/v1' + path, data);
const $patch = (path, data) => axios.patch(process.env.MIX_API_URL + '/v1' + path, data);
const $delete = (path) => axios.delete(process.env.MIX_API_URL + '/v1' + path);

const $putWithConfig = (path, data, config) => axios.put(process.env.MIX_API_URL + '/v1' + path, data, config);
const $postWithConfig = (path, data, config) => axios.post(process.env.MIX_API_URL + '/v1' + path, data, config);

api.seo = {
    checkProfile: (path) => $post('/seo/check-profile', {path: path}),
    generateUrl: (filter) => $post('/seo/generate-url', filter),
    getLocationInfo: (data) => $post('/seo/get-location-info', data),
    profileOrSearch: (path, location = null) => $post('/seo/profile-or-search', {
        path: path,
        location: location
    }),
};

api.auth = {
    register: (data) => $post('/auth/registration', data),
    registrationFromGallery: (data) => $post('/auth/registration-from-gallery', data),
    loginFromGallery: (data) => $post('/auth/login-from-gallery', data),
    me: () => $post('/auth/me'),
};

api.user = {
    edit: (data) => $put('/account/edit', data),
    getVerifyNumberData: (encoded) => $get('/user/verify-phone-data/' + encoded),
    sendPhoneVerificationCode: (payload) => $post('/user/send-phone-verify-sms/', payload),
    resendCode: (userIdHash) => $get('/user/re-send-code/' + userIdHash),
    resendVerificationEmail: (encoded) => $get('/user/resend-verification-email/' + encoded),
    changeEmail: (payload) => $put('/user/email/', payload),
    verifyCode: (encoded, code) => $get('/user/verify-code/' + encoded + '/' + code),
    verifyCodeAndUpdatePhone: (data) => $post('/user/verify-sms-and-update-phone', data),
    setRepublishDate: (data) => $put('/account/re_publish_date', data),
    getAdvert: () => $get('/account/advert'),
    unlockExplicitUser: (userId) => $get('/user/unlock-explicit-user/' + userId),
    change_password: (data) => $put('/account/change_password', data),
    changeOnboardingStep: (step) => $put(`/user/onboarding-step/${step}`),
    photos: {
        getProfilePhotos: () => $get('/profile/photos/profile'),
        delete_by_id: (data) => $post('/profile/photos/remove', data),
        update: (data) => $put('/profile/photos/update', data),
    },
    videos: {
        getProfileVideos: () => $get('/profile/videos/profile'),
        deleteVideos: (data) => $post('/profile/videos/remove', data),
        update: (data) => $put('/profile/videos/update', data),
        patchUserVideoIsExplicit: (userVideoId, data) => $patch(`/profile/videos/${userVideoId}/is-explicit`, data),
    },
    submit_verification: () => $put('/profile/verification', {}),
    publish_profile: (data) => $put('/account/publish', data),
    un_publish_profile: () => $put('/account/unpublish', {}),
    working_hours: {
        put: (data) => $put('/profile/working_hours', data),
    },
    faqs: {
        put: (data) => $put('/profile/faqs', data),
    },
    report: {
        post: (data) => $post('/users/report', data),
    },
    manager: {
        create: (data) => $post('/manager/create', data),
    },
    request_profile: (data) => $post('/users/request-profile', data),
    toggle_favorite_profile: (removeFromFavorites, id) => $get(`/users/favorite-profiles/${removeFromFavorites}/${id}`),
    get_favorite_profiles: () => $get('/users/favorite-profiles'),
    reviews: {
        create: (data) => $post('/users/reviews/', data),
        get: (userId) => $get(`/users/${userId}/reviews/`),
        reply: (reviewId, payload) => $post(`/users/reviews/${reviewId}/reply`, payload),
        delete: (reviewId) => $delete(`/users/reviews/${reviewId}`),
    },
    update_outcall_locations: (locations) => $put('/account/outcall_locations', {locations}),
    schedule_outcall_locations: (payload) => $put('/account/outcall_locations_schedule', payload),
    feedback: {
        call: {
            add: (payload) => $post('/users/feedback/call', payload),
        }
    },
    update_availability: (date) => $put('/account/availability', date),
    checkFreeAvailabilities: () => $get('/account/availability/check'),
    profile_views: () => $get('/profile/views'),
    notifications: () => $get('/users/notifications'),
    age_verification: (data) => $get('/users/age-verification'),
    saved_searches: {
        save: (payload) => $post('/users/saved-searches', payload),
        get: () => $get('/users/saved-searches'),
        updates: () => $get('/users/saved-searches/updates'),
        delete: (id) => $delete('/users/saved-searches/' + id),
    },
    venue: {
        features: {
            update: (payload) => $put('/users/venue/features', payload),
            get: () => $get('/users/venue/features'),
        },
        workingHours: {
            update: (payload) => $put('/users/venue/working_hours', payload),
            get: () => $get('/users/venue/working_hours'),
        }
    },
    creditsHistory: {
        get: () => $get('/user/credits-history'),
    },
    escort: {
        emergencyMeeting: {
            getAll: () => $get(`/escort-emergency-meetings/`),
            getPreviousMeetings: () => $get(`/escort-emergency-meetings/previous`),
            addMeeting: (payload) => $post(`/escort-emergency-meetings/`, payload),
            updateMeeting: (meetingId, payload) => $patch(`/escort-emergency-meetings/${meetingId}`, payload),
            updateStatus: (meetingId, status) => $patch(`/escort-emergency-meetings/${meetingId}/status/${status}`),
            getEmergencyMessage: () => $get(`/escort-emergency-meetings/message`),
            addOrCreateEmergencyMessage: (payload) => $put(`/escort-emergency-meetings/message`, payload),
            addEmergencyContact : (payload) => $post(`/escort-emergency-meetings/contacts`, payload),
            getEmergencyContacts : () => $get(`/escort-emergency-meetings/contacts`),
            updateEmergencyContacts : (contactId, payload) => $patch(`/escort-emergency-meetings/contacts/${contactId}`, payload),
            updateEmergencyContactsStatus : (contactId, status) => $patch(`/escort-emergency-meetings/contacts/${contactId}/${status}`),
            deleteEmergencyContacts : (contactId) => $delete(`/escort-emergency-meetings/contacts/${contactId}`),
        }
    }
};

api.conversations = {
    get: () => $get('/conversations'),
    post: (payload) => $post('/conversations', payload),
    seen: (conversationId) => $put(`/conversations/${conversationId}/seen`),
    hideConversation: (conversationId) => $delete (`/conversations/${conversationId}`),
    report: (conversation, payload) => $post(`/conversations/${conversation}/report`, payload),
    messages: {
        get: (conversationId) => $get(`/conversations/${conversationId}/messages`),
        post: (conversationId, payload) => $post(`/conversations/${conversationId}/messages`, payload)
    }
};

api.services = {
    list: () => $get('/services'),
    update: (ids) => $put('/services', {ids: ids}),
};

api.prices = {
    time_slots: () => $get('/prices/time_slots'),
    update: (prices) => $put('/prices', {prices}),
    range: () => $get('/prices/range'),
};

api.search = {
    getEscortsByLocation: (payload) => $post('/search/escorts', payload),
    random: () => $get('/search/random'),
    locations: (query) => $get('/search/locations/?query=' + query),
    suggestedLocations: (query) => $get('/search/suggested-locations/?query=' + query),
    solads: (adsCount) => $get('/search/partner/solad/' + adsCount),
    susiLive: (adsCount) => $get('/search/partner/susi-live/' + adsCount),
    visitX: (adsCount) => $get('/search/partner/visitx/' + adsCount),
    stripChat: (adsCount) => $get('/search/partner/strip-chat/' + adsCount),
};

api.features = {
    options: () => $get('/features/options'),
    update: (payload) => $put('/features', payload),
    ranges: () => $get('/features/ranges'),
};

api.products = {
    by_type: (payload) => $post('/products/by_type', payload),
    purchase: (payload) => $post('/products/purchase', payload),
    minimalPrices: (payload) => $get('/products/minimal_prices'),
    setProductPublishDate: (payload) => $post('/products/purchase/set_publish_date', payload),
};

api.transaction = {
    getTransaction: (payload) => $get(`/transactions${utils.params(payload)}`),
    initiateTransaction: (payload) => $post('/transactions', payload),
    updateManualTransaction: (transactionId, payload) => $put(`/transactions/${transactionId}`, payload),
    getPaysafe: (payload) => $get(`/transactions/paysafe${utils.params(payload)}`),
    getSofort: (payload) => $get(`/transactions/sofort${utils.params(payload)}`),
    getCashtoCode: (payload) => $get(`/transactions/cashtocode${utils.params(payload)}`),
    getBankTransfer: (payload) => $get(`/transactions/bank_transfer${utils.params(payload)}`),
    postBankTransfer: (payload) => $post('/transactions/bank_transfer', payload),
    createPayPalTransaction: (payload) => $post('/transactions/paypal/order', payload),

    getMicroPayment: (payload) => $post(`/transactions/micro-payment/online-bank-transfer`, payload),

    // @deprecated
    paypalLink: (payload) => $post('/transactions/paypal', payload),
    getPaypalTransaction: (payload) => $get(`/transactions/paypal${utils.params(payload)}`),
};

api.admin = {
    verifications: {
        get: (payload) => $get('/admin/verifications' + utils.params(payload)),
        getOne: (id) => $get('/admin/verifications/' + id),
        setStatus: (id, payload) => $put('/admin/verifications/' + id, payload),
    },
    portals: {
        get: () => $get('/admin/portals'),
    },
    users: {
        all: (payload = {}) => $get('/admin/users' + utils.params(payload)),
        quarantined: (payload = {}) => $get('/admin/users/quarantined/' + utils.params(payload)),
        quarantinedPublish: (userId = {}) => $post(`/admin/users/${userId}/quarantined/publish/`),
        quarantinedReject: (userId = {}) => $put(`/admin/users/${userId}/quarantined/reject/`),
        definedLanguages: () => $get('/admin/users/defined-languages'),
        updateLanguageSettings: (payload = {}) => $post('/admin/users/language-settings', payload),
        update: (userId, payload) => $put('/admin/users/' + userId, payload),
        homePageProfilesList: (portalId, stateId) => $get(`/admin/users/home-page-profiles/${portalId}/${stateId}`),
        homePageProfilesListWithoutState: (portalId, stateId) => $get(`/admin/users/home-page-profiles/${portalId}/`),
        homePageProfilesUpdate: (portalId, stateId, payload) => $put(`/admin/users/home-page-profiles/${portalId}/${stateId}`, payload),
        homePageProfilesUpdateWithoutState: (portalId, stateId, payload) => $put(`/admin/users/home-page-profiles/${portalId}/`, payload),
        creditSources: () => $get('/admin/users/credit-sources/'),
        disableUser: (payload) => $post('/admin/users/disable-user/', payload),
        enableUser: (payload) => $post('/admin/users/enable-user/', payload),
        changeUsername: (payload) => $post('/admin/users/change-username/', payload),
        changePassword: (user, password) => $post(`/admin/users/${user}/changePassword`, {password,}),
        changeManager: (payload) => $post('/admin/users/change-manager/', payload),
        addVip: (payload) => $post('/admin/users/add-vip/', payload),
        abuse: {
            reports: (payload = {}) => $get('/admin/users/escorts-abuse-reports' + utils.params(payload)),
            reviewStatuses: () => $get('/admin/users/escorts-abuse-reports/statuses'),
            reportShow: (id) => $get('/admin/users/escorts-abuse-reports/' + id),
            updateReport: (id, payload) => $put('/admin/users/escorts-abuse-reports/' + id, payload),
            closeAll: (userId, payload) => $put('/admin/users/escorts-abuse-reports/close-all/' + userId, payload),
        },
        events: {
            get: (userId) => $get('/admin/users/' + userId + '/events'),
            create: (payload) => $post('/admin/users/events', payload),
        },
        pipedriveUsers: (payload = {}) => $get('/admin/users/pipedrive/users' + utils.params(payload)),
        updatePipedriveUsers: (payload = {}) => $post('/admin/users/pipedrive/users', payload),
        rafUsers: (payload = {}) => $get('/admin/users/raf/users' + utils.params(payload)),
        rafUpdateUser: (payload = {}) => $post('/admin/users/raf/users', payload),
        rafStatuses: () => $get('/admin/users/raf/statuses'),
        photos: (payload = {}) => $get('/admin/users/photos' + utils.params(payload)),
        updateFskStatus: (payload = {}) => $put('/admin/users/photos/fsk/update', payload),
        register: (data) => $post('/admin/users/registration', data),
        changePremium: (userId, payload) => $put(`/admin/users/${userId}/modify-premium`, payload),
        ageVerification: (userId, payload) => $put(`/admin/users/${userId}/age-verification`, payload),
        credits: {
            history: (userId) => $get(`/admin/users/${userId}/credits-history`),
            types: () => $get('/admin/users/credit-types'),
            withdraw: (userId, payload) => $put(`/admin/users/${userId}/credits/withdraw`, payload),
        },
        transactions: {
            pendingTransactions: (payload = {}) => $get('/admin/users/pending-transactions' + utils.params(payload)),
            hideTransaction: (payload) => $put('/admin/users/pending-transactions', payload),
            negative: {
                reasons: () => $get('/admin/users/negative-transactions-reasons'),
            }
        },
        profileLocks: {
            getList: () => $get('/admin/users/locked-profiles'),
            // because php upload works only with post
            addToList: (payload, config) => $postWithConfig('/admin/users/locked-profiles', payload, config),
            removeFromList: (userId) => $delete(`/admin/users/locked-profiles/${userId}`),
        },
        locations: {
            list: (user, page) => $get(`/admin/users/${user}/locations?page=${page}`),
            update: (user, payload) => $post(`/admin/users/${user}/locations`, payload),
            delete: (locationId) => $delete(`/admin/users/locations/${locationId}`),
        },
        giveEscortProductTrial: (userId, payload) => $post(`/admin/users/${userId}/escort-product-trial`, payload),
        purchaseProductAsUser: (userId, productId) => $post(`/admin/users/${userId}/products/${productId}/purchase`),
    },
    services: {
        updateAll: (payload) => $put('/services/all', payload),
    },
    configuration: {
        productsAll: () => $get('/admin/configurations/products'),
        productsUpdate: (payload) => $post('/admin/configurations/products', payload),
    },
    advert: {
        create: (payload, config) => $postWithConfig('/admin/configurations/advert', payload, config),
        update: (id, payload, config) => $putWithConfig('/admin/configurations/advert/' + id, payload, config),
        list: () => $get('/admin/configurations/advert'),
        get: (id) => $get('/admin/configurations/advert/' + id),
    },
    bulkMessaging: {
        list: () => $get('/admin/bulk-messaging'),
        insert: (payload) => $post('/admin/bulk-messaging', payload),
        update: (id, payload) => $put('/admin/bulk-messaging/' + id, payload),
        recall: (message) => $delete(`/admin/bulk-messaging/${message}`),
    },
    profileAdverts: {
        list: () => $get('/admin/profile-adverts'),
        sync: (payload) => $post('/admin/profile-adverts', payload),
    },
    searchAdverts: {
        list: () => $get('/admin/search-adverts'),
        update: (payload) => $put('/admin/search-adverts', payload),
        remove: (id) => $delete(`/admin/search-adverts/${id}`),
    },
    cashToCode: {
        generate: (payload) => $post('/admin/cash-to-code/generate-url', payload),
    },
    cloudflare: {
        whitelist: (ip) => $post('/admin/cloudflare/whitelist-ip', {ip}),
    },
    uniquePayByCreditCard: {
        generate: (payload) => $post('/admin/unique-pay-by-credit-card-generator', payload),
    },
    categories: {
        fetchAll: () => $get('/admin/categories'),
    },
};

api.manager = {
    venue: {
        update: (userId, payload) => $put('/manager/' + userId, payload),
    },
    user: {
        attachVenue: (payload) => $post('/manager/attach-venue', payload),
    }
};

api.gallery = {
    purchase: (gallery, days) => $post(`/users/galleries/${gallery}`, {days,}),
    //single private gallery
    private: {
        get: () => $get('/account/private_gallery'),
        setPrices: (payload) => $put('/account/private_gallery/prices', payload),
        upload: (payload, settings) => $putWithConfig('/account/private_gallery/upload', payload, settings),
        update: (payload) => $put('/account/private_gallery', payload),
        updateVideos: (payload) => $put('/account/private_gallery/videos', payload),
        deletePhotos: (payload) => $put('/account/private_gallery/deletePhotos', payload),
        deleteVideos: (payload) => $put('/account/private_gallery/delete-videos', payload),
    },
    list: (userId) => $get(`/users/${userId}/galleries`),
    images: (galleryId) => $get(`/users/galleries/photos/${galleryId}`),
    videos: (galleryId) => $get(`/users/galleries/videos/${galleryId}`),
    purchased: () => $get('/users/galleries/subscribed'),
    patchGalleryVideoIsExplicit: (galleryVideoId, data) => $patch(`/users/galleries/videos/${galleryVideoId}/is-explicit`, data),
};

api.locale = {
    change: (locale) => $get(`/locale/${locale}`)
}

api.captcha = {
    registration: () => $get('/captcha/registration'),
}

api.countryCode = {
    getAll: () => $get('/country-codes'),
}

api.states = {
    list: () => $get('/states/'),
}

api.regionData = {
    all: () => $get('/region-data'),
}

export default api;
